import React from 'react'

import { pepRelationshipTypes } from 'utils/constants/DueDiligenceRelations'
import { formatInBrazilianDate } from 'utils/functions'
import DisplayAnswerItems from './DisplayAnswerItems'

import styles from './styles'

function DisplayPEPRelations(props) {
  const { questionData: answerData } = props
  const classes = styles()

  const buildPEPRelation = (activityInfo) => {
    return (
      <div className={classes.answersContainer} key={activityInfo.key}>
        <p>
          <span>Nome completo do PEP: </span>
          {activityInfo.pep_name}
        </p>
        {activityInfo.pep_type === 'related' ? (
          <p>
            <span>Natureza do relacionamento: </span>
            {pepRelationshipTypes[activityInfo.kinship_degree]}
          </p>
        ) : null}
        <p>
          <span>Cargo: </span>
          {activityInfo.role}
        </p>

        <p>
          <span>Atividades desempenhadas: </span>
          {activityInfo.developed_activities}
        </p>
        <p>
          <span>Reporta/reportava-se a: </span>
          {activityInfo.reports_to}
        </p>
        {activityInfo.end_of_contract ? (
          <p>
            <span>Fim do vínculo: </span>
            {formatInBrazilianDate(activityInfo.end_of_contract)}
          </p>
        ) : null}

        {activityInfo.currently_at_this_job ? (
          <p>
            <span>Jornada de trabalho: </span>
            {` ${activityInfo.start_working_hours} às ${activityInfo.end_working_hours}.`}
          </p>
        ) : null}
        {activityInfo.pep_type === 'holder' ? (
          <p>
            <span>Jornada da atividade de assessoria: </span>
            {` ${activityInfo.investment_advisory_start_time} às ${activityInfo.investment_advisory_end_time}.`}
          </p>
        ) : null}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento dos casos de PEP:</h3>

      <DisplayAnswerItems
        answerData={answerData}
        noDataMessage="Não é ou não possui relação com pessoa exposta politicamente."
        funcBuildItem={buildPEPRelation}
      />
    </div>
  )
}
export default DisplayPEPRelations
